import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.NEWSLETTER.SUBSCRIBED, ({ user }) => {
  window.dataLayer.push({
    event: 'newsletter_signup',
    email: user.email,
  })
})
